// extracted by mini-css-extract-plugin
export default {"container":"XF-z","modal":"YF-z","dimensions":"ZF-z","brandName":"_F-z","productName":"aG-z","labelValue":"bG-z","recipientEmail":"cG-z","recommendedFit":"dG-z","hiddenField":"eG-z"};